import { gql } from '@apollo/client';

export const GET_LIST_FACEBOOK_PAGES = gql`
  query GetList($socmed_account_id: String!) {
    GetFacebookPages(socmed_account_id: $socmed_account_id) {
      data
    }
  }
`;

export const GET_LIST_FACEBOOK_POST = gql`
  query GetList(
    $page_id: String!
    $pagination: FacebookPagination
    $page_access_token: String!
  ) {
    GetListFacebookPost(
      page_id: $page_id
      pagination: $pagination
      page_access_token: $page_access_token
    ) {
      data
    }
  }
`;

export const GET_LIST_FACEBOOK_ADS_POST = gql`
  query GetList(
    $page_id: String!
    $pagination: FacebookPagination
    $page_access_token: String!
  ) {
    GetListFacebookAdsPost(
      page_id: $page_id
      pagination: $pagination
      page_access_token: $page_access_token
    ) {
      data
    }
  }
`;

export const GET_LIST_FACEBOOK_SCHEDULED_POST = gql`
  query GetList(
    $page_id: String!
    $pagination: FacebookPagination
    $page_access_token: String!
  ) {
    GetListFacebookScheduledPost(
      page_id: $page_id
      pagination: $pagination
      page_access_token: $page_access_token
    ) {
      data
    }
  }
`;

export const GET_LIST_FACEBOOK_INSTAGRAM_POST = gql`
  query GetList(
    $page_id: String!
    $pagination: FacebookPagination
    $page_access_token: String!
  ) {
    GetListFacebookInstagramsPosts(
      page_id: $page_id
      pagination: $pagination
      page_access_token: $page_access_token
    ) {
      data
    }
  }
`;

export const GET_FACEBOOK_POST_BY_ID = gql`
  query ($post_id: String!, $page_access_token: String!) {
    GetFacebookPost(post_id: $post_id, page_access_token: $page_access_token) {
      data
    }
  }
`;

export const GET_FACEBOOK_AD_ACCOUNT = gql`
  query GetFacebookAdAccount($socmed_account_id: String!, $fields: [String!]!) {
    list: GetFacebookAdAccount(
      socmed_account_id: $socmed_account_id
      fields: $fields
    ) {
      data
    }
  }
`;
